import { defineStore } from 'pinia'

export const aiToolsStore = defineStore('aiToolsStore', {
  state: () => {
    return {
      scriptImageList: [],
      chatName: '',
      activeKey: 'textWork',
      drawerOpenVal: false,
      deepCopyAdanceList: [],
      currentId: '',
      changeTabs: false,
      textId: '',
      imageId: '',
      videoId: '',
      recentlyUsed: '',
      collect: '',
      skip: false
      // videoRetrievalData: {
      //   typeTitle: '',
      //   dataList: [],
      //   selectVal: '',
      //   loading: '',
      //   total: '',
      //   current: ''
      // }
    }
  },
  getters: {},
  //可以操作异步 和 同步提交state
  actions: {
    // setvideoRetrievalData(state, value) {
    //   state.videoRetrievalData = value
    // },
    setRecentlyUsed(state, value) {
      state.RecentlyUsed = value
    },
    setSkip(state, value) {
      state.Skip = value
    },
    setCollect(state, value) {
      state.Collect = value
    },
    setChatName(state, value) {
      state.chatName = value
    },
    setActiveKey(state, value) {
      state.activeKey = value
    },
    setCurrentId(state, value) {
      state.currentId = value
    },
    setdeepCopyAdanceList(state, value) {
      state.deepCopyAdanceList = value
    },
    setChangeTabs(state, value) {
      state.changeTabs = value
    },
    setTextId(state, value) {
      state.textId = value
    },
    setImageId(state, value) {
      state.imageId = value
    },
    setVideoId(state, value) {
      state.videoId = value
    }
  }
})
